import { render } from "./LegalDocumentSeal.vue?vue&type=template&id=9da3f4c0&scoped=true"
import script from "./LegalDocumentSeal.vue?vue&type=script&lang=js"
export * from "./LegalDocumentSeal.vue?vue&type=script&lang=js"

import "./LegalDocumentSeal.vue?vue&type=style&index=0&id=9da3f4c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da3f4c0"]])

export default __exports__